'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from '../../utils/cn';
const Table = forwardRef(({ className, children, ...props }, ref) => (_jsx("div", { id: "tableScrollBar", className: "relative w-full overflow-auto", children: _jsx("table", { ref: ref, className: cn('w-full overflow-hidden rounded-2xl bg-white text-body-4 dark:bg-metal-900', className), ...props, children: children }) })));
Table.displayName = 'Table';
export { Table };
